import { Ref, computed, ref } from "vue";

const isPc: number = 1200;
const isPad: number = 680;
const viewWidth: Ref<number> = ref<number>(document.body.offsetWidth);
const isMobile = computed(() => viewWidth.value <= isPad);

const isTest: Ref<boolean> = ref<boolean>(false);
const clickBodyNode: Ref<number> = ref<number>(0);

export { isPc, isPad, isMobile, viewWidth, isTest, clickBodyNode };
